import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '8px',
      gap: '10px',
      padding: '16px',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      cursor: 'pointer',
    },
    title: {
      fontWeight: 400,
      fontSize: '16px',
      color: 'rgba(0, 0, 0, 1)',
    },
    subTitle: {
      fontWeight: 400,
      fontSize: '12px',
      color: 'rgba(0, 0, 0, 0.6)',
    },
  }
))
